module.exports = __webpack_public_path__ + "static/media/haml.781a01e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/haml.png
// module id = 31
// module chunks = 0